<div>
    <div class="hero">
  
    </div>
  
    <div class="sponsorship-view" *ngIf="sponsorshipItem">
      <div class="form-title">Redemption Status</div>
  
      <div class="sponsorship-item">
        <h5>Sponsorship {{ number }}</h5>
        <h5 class="gift-name">{{giftItemName(sponsorshipItem)}}</h5>

        <div>
          <label class="key">Purchased: </label>
          {{sponsorshipItem.created_at | date:'fullDate'}}
        </div>

        <div>
          <label class="key">Redemptions to date: </label>
          {{sponsorshipItem.redemptions_count || 0}}
        </div>

        <div *ngIf="sponsorshipItem.gift_redemptions.length">
          <label class="key">First Redemption: </label>
          {{firstRedemption | date:'fullDate'}}
        </div>

        <div *ngIf="sponsorshipItem.gift_redemptions.length">
          <label class="key">Most Recent Redemption: </label>
          {{mostRecentRedemption | date:'fullDate'}}
        </div>

      </div>

      <hr/>

      <h5 *ngIf="sponsorshipItem.gift_redemptions.length">Thank you notes from recipients</h5>
      <ng-container *ngFor="let redemption of sponsorshipItem.gift_redemptions">
        <div>
          <label class="key">From: </label>
          {{redemption.redeemer_name ?  capitalizeFirstLetter(redemption.redeemer_name) : 'Anonymous'}}
        </div>

        <div>
          <label class="key">Date: </label>
          {{redemption.redeemed_at | date:'fullDate'}}
        </div>

        <div>
          <label class="key">Message: </label>
          <blockquote>{{redemption.message}}</blockquote>
        </div>

        <br/>
      </ng-container>

      <a routerLink="/account">Back to Account</a>
    </div>
  </div>